import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { bindActionCreators } from 'redux';
import * as layoutActions from '../../../actions/layoutActions';
import { getTypeValueByDataset } from '_legacy/components/grid/formatters/TypeFormatter';
import { typesByDataset } from '_legacy/models/Type';

const panelContainerStyle = () => {
    return {
        textAlign: 'left',
        display: 'inline-grid',
        lineHeight: '1.5',
        marginTop: '5px',
        marginLeft: '50px',
        width: '150px',
    };
};

const DefaultTypeItems = (props) => {
    const tankersGroupType =
        props.api?.gridOptionsWrapper?.gridOptions?.context?.tankersGroupType;

    const options = typesByDataset(props.datasetId, tankersGroupType).map(
        (x) => ({
            value: x,
            label: x,
        })
    );

    options.forEach((o) => {
        o.label = getTypeValueByDataset(o.value, props.datasetId);
    });

    const [defaultType, setDefaultType] = useState(() => {
        return (
            options.find((type) => type.value === props.currentDefaultType) ||
            options[0]
        );
    });

    useEffect(() => {
        const newMatchingOption =
            options.find((type) => type.value === props.currentDefaultType) ||
            options[0];

        // Only update if the value actually changed
        if (newMatchingOption?.value !== defaultType?.value) {
            setDefaultType(newMatchingOption);
        }
    }, [props.currentDefaultType, tankersGroupType, props.datasetId]);

    const handleOnChangeDefaultTypeFormat = (type) => {
        setDefaultType(type);
        updateLayout(type.value);
        props.api.refreshClientSideRowModel();
    };

    const updateLayout = (type) => {
        props.actions.onDefaultTypeChanged(type);
    };

    return (
        <div style={panelContainerStyle()}>
            <Select
                className="basic-single"
                classNamePrefix="list"
                isSearchable={false}
                options={options}
                onChange={handleOnChangeDefaultTypeFormat}
                value={defaultType}
                openMenuOnFocus={true}
                menuPlacement="auto"
                placeholder="Default type"
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    const props = {
        currentDefaultType:
            state.layouts.selectedLayout.commonSettings.defaultType
                .currentState,
    };

    return props;
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators({ ...layoutActions }, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DefaultTypeItems);
